export enum FormMode {
  Scratch,
  ForProduct,
  ForPurchase,
  ForConsumer,
}
